<template>
    <div class="animated fadeIn" v-if="is(func)">
        <b-card>
            <b-form-group label="Наименование функции">
                <input v-model="func.title" class="form-control" />
            </b-form-group>

            <b-form-group label="Идентификатор функции">
                <input v-model="func.slug" class="form-control" />
            </b-form-group>

            <b-form-group label="Параметры функции" description="через запятую">
                <input v-model="func.parameters" class="form-control" />
            </b-form-group>

            <b-form-group label="Тип функции">
                <select v-model="func.type" class="form-control" >
                    <option value="1">Основной workflow</option>
                    <option value="2">Отмена, удаление</option>
                    <option value="3">Ошибка, исключение</option>
                    <option value="4">Дальний переход</option>
                    <option value="5">Дальний возврат</option>
                    <option value="6">Печать документа, отчета</option>
                    <option value="7">Действие не изменяющее состояние</option>
                    <option value="0">По умолчанию</option>
                </select>
            </b-form-group>

            <b-form-group label="Описание функции">
                <textarea v-model="func.info" class="form-control"></textarea>
            </b-form-group>

            <div class="row">
                <div class="col col-md-6">
                    <b-form-group label="Конечное состояние">
                        <div class="input-group">
                            <b-form-select :options="states" v-model="func.state_to_id" value-field="id" text-field="title"></b-form-select>
                            <button type="button" class="btn btn-secondary" @click="func.state_to_id=null"><i class="fa fa-times"></i></button>
                        </div>
                            <p v-if="func.state_to_id">
                                <router-link :to="{ path: '/admin/sm/state/'+func.state_to_id }"  >
                                    {{ func.state_to.title }}
                                </router-link>
                            </p>
                    </b-form-group>
                </div>

                <div class="col col-md-6">
                    <b-form-group label="Условия">
                        <multiselect
                            v-model="func.conditions"
                            :options="conditions"
                            :multiple="true"
                            label="title"
                            track-by="title"></multiselect>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-md-6">
                    <b-form-group label="Состояния">
                        <multiselect
                            v-model="func.states"
                            :options="states"
                            :multiple="true"
                            label="title"
                            track-by="title"></multiselect>
                    </b-form-group>
                    <b-form-group>
                        <button class="btn btn-primary" @click="selectAllStates">Выбрать все</button>
                    </b-form-group>
                </div>


            </div>

            <b-form-group>
                <button @click="doSave()"><i class=""></i> Сохранить</button>
            </b-form-group>

        </b-card>

    </div>
</template>

<script>
    import { functions } from '@/functions';
    import { functions_sm } from '@/functions_sm.js';

    export default {
        name: 'SmFunction',
        components: {},
        mixins: [functions, functions_sm],
        data: function () {
            return {
                func_id: null,
                cond:null,
            }
        },
        created: function() {
            this.loadStates();
            this.loadConditions();
        },
        methods: {
            doSave:function () {
                this.httpPrepare();
                this.$http.put(this.apiurl('sm/func/'+this.func_id+'/save'), {func:this.func}).then(function (response) {
                    response = this.httpSuccess(response);
                    this.loadFunc();
                }, this.httpError);
            },
            selectAllStates:function () {
                this.func.states = this.states.slice();
            }
        },
        watch: {
            '$route.params': {
                handler(newValue) {
                    if (newValue) {
                        this.func_id = this.$router.currentRoute.params.func_id;
                        this.loadFunc();
                    }
                },
                immediate: true,
            },
        }
    };
</script>

<style lang="scss"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
